module.exports = __webpack_public_path__ + "img/icon-xyqx.e7a1c983.png";